/**
 *
 *  Bottom Navigation for User Profile Page
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 07/03/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React from "react";
import BottomNavLink from "./BottomNavLink/BottomNavLink";

// Components
import ToggleChatButton from "../Buttons/ToggleChatButton/ToggleChatButton";

// Icons
import CalendarIcon from "../../icons/CalendarIcon";
import HomeIcon from "../../icons/HomeIcon";
import CardIcon from "../../icons/CardIcon";
import UserIcon from "../../icons/UserIcon";
import MessagesIcon from "../../icons/MessagesIcon";

export default function BottomNavigation() {
  return (
    <div className="tbk-fixed tbk-left-0 tbk-right-0 tbk-bottom-0 tbk-z-[1003] tbk-bg-basic-white tbk-shadow-trube">
      <div className="tbk-flex tbk-h-7">
        <ul
          component="nav"
          aria-label="mailbox folders"
          className="tbk-flex tbk-grow tbk-items-center tbk-justify-evenly tbk-p-0"
        >
          <li>
            <BottomNavLink to="/account" linkIcon={<HomeIcon />} text="Home" />
          </li>
          <li>
            <BottomNavLink
              to="/account/bookings"
              linkIcon={<CalendarIcon />}
              text="Bookings"
            />
          </li>
          {/*<li>*/}
          {/*  <BottomNavLink*/}
          {/*    to="/account/payments"*/}
          {/*    linkIcon={<CardIcon />}*/}
          {/*    text="Payments"*/}
          {/*  />*/}
          {/*</li>*/}
          <li>
            <ToggleChatButton />
            {/*<BottomNavLink
              to="/account/messages"
              linkIcon={<MessagesIcon />}
              text="Messages"
            />*/}
          </li>
          <li>
            <BottomNavLink
              to="/account/settings"
              linkIcon={<UserIcon />}
              text="Account"
            />
          </li>
        </ul>
      </div>
    </div>
  );
}
